import * as React from "react";

interface Book { id: Number, title: string, book_series: string, cover_url: string }
interface Post { id: Number, text: string, book: Book, user: string };
interface PostGameState { data: Array<Book>, correctResult: Post, previousResult: Book, photoUrl: string, answer_state: string, score: number, numAnswered: number, loading: boolean };
interface PostResponse { books: Array<Book>, correct_result: Post, photo_url: string };

const STATES = {
  unanswered: 'UNANSWERED',
  correct: 'CORRECT',
  wrong: 'WRONG'
}

export default class BookGame extends React.Component<{}, PostGameState> {
  constructor(props: Readonly<{}>) {
    super(props);
    this.state = {
      data: [],
      correctResult: null,
      previousResult: null,
      photoUrl: null,
      answer_state: STATES.unanswered,
      score: 0,
      numAnswered: 0,
      loading: false
    };
    this.fetchData = this.fetchData.bind(this);
  }

  async requestData() {
    const response = await fetch(
      "/api/book_game.json"
    );
    return await response.json() as Promise<PostResponse>;
  };

  fetchData() {
    this.setState({ loading: true });
    this.requestData().then(res => {
      const { books, correct_result, photo_url } = res;
      this.setState({
        data: books,
        correctResult: correct_result,
        photoUrl: photo_url,
        loading: false
      });
    });
  }

  componentDidMount() {
    this.fetchData();
  }

  selectResult(id: Number) {
    const { correctResult, score, numAnswered } = this.state;
    this.setState({ numAnswered: numAnswered + 1, previousResult: correctResult.book });
    if (id == correctResult.book.id) {
      this.setState({ score: score + 1, answer_state: STATES.correct });
    } else {
      this.setState({ answer_state: STATES.wrong });
    }
    this.fetchData();
  }

  renderSelection(book: Book) {
    return (
      <div key={`book_${book.id}`} className='flex flex-row gap-2 items-center'>
        <button type="button" className='p-2 bg-emerald-600 rounded text-white' onClick={(e) => this.selectResult(book.id)} id={`link_${book.id}`}>SELECT</button>
        {this.renderBook(book)}
      </div>
    )
  }

  renderAnswer() {
    const { answer_state, previousResult } = this.state;
    if (answer_state == STATES.unanswered) {
      return null;
    }
    switch (answer_state) {
      case STATES.unanswered:
        return null;
      case STATES.correct:
        return (
          <div className='flex flex-col gap-2 p-2 bg-emerald-200 rounded text-emerald-800'>
            <h4 className="text-xl">Correct</h4>
            {this.renderBook(previousResult)}
          </div>
        );
      case STATES.wrong:
        return (
          <div className='flex flex-col gap-2 p-2 bg-red-200 rounded text-red-800'>
            <h4 className="text-xl">WRONG</h4>
            {this.renderBook(previousResult)}
          </div>
        );
    }
  }

  renderScore() {
    const { score, numAnswered } = this.state;

    if (numAnswered == 0) {
      return null;
    }

    const percent = 100.0 * score / numAnswered;

    return (
      <p>
        Score ({score}/{numAnswered}), {percent}%
      </p>
    );
  }

  renderQuestion() {
    const { correctResult, photoUrl } = this.state;

    if (correctResult) {
      return (
        <div className="flex flex-col border border-slate-700 gap-2 p-4">
          <p className="font-medium text-lg">{correctResult.user}</p>
          <p className="whitespace-pre-wrap">{correctResult.text}</p>
          <img src={photoUrl}></img>
        </div>
      );
    }

    return null;
  }

  renderBook(book: Book) {
    return (
      <div className='flex flex-row gap-2'>
        <img src={book.cover_url} />
        <div className="flex flex-col gap-1">
          <strong>{book.book_series}:</strong>
          <h4 className="text-xl"><cite>{book.title}</cite></h4>
        </div>
      </div>
    );
  }

  render() {
    const { data, loading } = this.state;

    if (loading) {
      return (
        <h1 className="text-4xl">Loading...</h1>
      );
    }

    return (
      <div className="flex flex-col gap-4">
        {this.renderAnswer()}
        {this.renderScore()}
        {this.renderQuestion()}
        <div className='flex flex-col gap-2'>
          {data.map((Book) => (this.renderSelection(Book)))}
        </div>
      </div>
    );
  }
}
